import { createFileRoute, redirect } from "@tanstack/react-router";

import { hasPermission } from "@/modules/auth/lib/permissions";
import { WorkListPage } from "@/modules/work/pages/WorkList.page";

export const Route = createFileRoute("/__authed/m/work")({
	beforeLoad({ context }) {
		const user = "user" in context ? context.user : undefined;

		if (!hasPermission(user, "see_work")) {
			throw redirect({ to: "/m/dashboard" });
		}
	},
	component: WorkListPage,
});
